// extracted by css-extract-rspack-plugin
export default {"navItemsWrapper":"nav-items-wrapper--fwVBBbulY0LGTeTW","navItem":"nav-item--na3y4mBZo0EzEBnU"};